import { useEffect, useRef, useState } from 'react';

import { calcTimeToEndFromNow } from '../lib/date';

const useTimerToEnd = (
  endTime?: string | null,
  callback?: () => void,
): number | null => {
  const timerId = useRef<undefined | NodeJS.Timeout>(undefined);
  const [seconds, setSeconds] = useState<number | null>(null);

  useEffect(() => {
    if (endTime) {
      const calcResult = (): number => {
        const miliseconds = calcTimeToEndFromNow(endTime);
        const seconds = Math.ceil(miliseconds / 1000);

        return seconds < 0 ? 0 : seconds;
      };

      setSeconds(calcResult());

      timerId.current = setInterval(() => {
        const result = calcResult();
        setSeconds(result);

        if (result === 0) {
          callback?.();
          clearInterval(timerId.current);
        }
      }, 1000);
    }

    return (): void => {
      clearInterval(timerId.current);
    };
  }, [endTime]);

  return seconds;
};

export { useTimerToEnd };
